import * as React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useDataProvider, useTranslate } from 'ra-core';
import { ApiSelectionModalTaC } from './ApiSelectionModalTaC';
import { useLayer7Notify } from '../../useLayer7Notify';
export function ApiGroupSelectionModal(props) {
    var _a;
    const { apiGroup, onConfirm, onCancel, orgUuid } = props;
    const [apiGroupEula, setApiGroupEula] = React.useState();
    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const notify = useLayer7Notify();
    const classes = useStyles(props);
    React.useEffect(() => {
        async function fetchApiGroupEula() {
            const { data } = await dataProvider.getApiGroupEula('apiGroups', {
                apiGroupId: apiGroup.id,
                filter: { OrganizationUuid: orgUuid },
            }, {
                onFailure: error => notify(error),
            });
            setApiGroupEula(data);
        }
        if (apiGroup) {
            fetchApiGroupEula();
        }
    }, [JSON.stringify(apiGroup)]); // eslint-disable-line
    return (React.createElement(Dialog, { fullWidth: true, maxWidth: "md", open: !!apiGroup, onClose: onCancel, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" },
        React.createElement(React.Fragment, null,
            React.createElement(DialogTitle, { id: "alert-dialog-title" }, apiGroup === null || apiGroup === void 0 ? void 0 :
                apiGroup.name,
                " (", (_a = apiGroup === null || apiGroup === void 0 ? void 0 : apiGroup.apis) === null || _a === void 0 ? void 0 :
                _a.length,
                ")"),
            React.createElement(DialogContent, null,
                React.createElement(ApiSelectionModalTaC, { content: apiGroupEula === null || apiGroupEula === void 0 ? void 0 : apiGroupEula.content })),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: onCancel, color: "primary" }, translate('ra.action.cancel')),
                React.createElement(Button, { onClick: onConfirm, color: "primary", autoFocus: true }, translate('resources.applications.actions.accept_terms_and_conditions'))))));
}
const useStyles = makeStyles(theme => ({
    heading: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightBold,
        color: theme.palette.grey[600],
        marginBottom: theme.spacing(3),
    },
    planSummaryTable: {
        marginLeft: theme.spacing(1),
        width: '97%',
    },
    table: {
        minWidth: '100%',
    },
    container: {
        maxHeight: '100%',
    },
}), {
    name: 'Layer7ApplicationApiPlansList',
});
//# sourceMappingURL=ApiGroupSelectionModal.js.map